import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "../config";

// const API_BASE_URL = process.env.REACT_APP_API_URL as string;
const API_BASE_URL = config.API_BASE_URL || process.env.REACT_APP_API_URL as string;


// Create Axios instance for public API calls (no authentication required)
const publicApi: AxiosInstance = axios.create({
  baseURL: API_BASE_URL.toString(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Handle response errors globally
publicApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    console.error("Public API Error:", error);
    return Promise.reject(error);
  },
);

export default publicApi;
